import { useId } from 'react'
import { CALENDAR_FALLBACK_TOOLTIP, hasNationalCalendarFallback } from './calendarFallback'
import './CalendarFallbackIcon.css'

export default function CalendarFallbackIcon({ source, fallbackUsed = false }) {
  const tooltipId = useId()
  if (!fallbackUsed && !hasNationalCalendarFallback(source)) return null
  return <span className="calendar-fallback-icon" role="img" tabIndex={0} title={CALENDAR_FALLBACK_TOOLTIP}
    aria-label="Calendário nacional utilizado" aria-describedby={tooltipId}>
    <i className="fas fa-triangle-exclamation" aria-hidden="true" />
    <span id={tooltipId} role="tooltip" className="calendar-fallback-tooltip">{CALENDAR_FALLBACK_TOOLTIP}</span>
  </span>
}
